module.exports = __webpack_public_path__ + "images/help/cloud-big-ec4a832d01f8e88d559fea95310b5034.png";